import { t as e } from "./cx-BjmrJCen.js";
/* empty css                              */
import { jsx as t } from "react/jsx-runtime";
//#region src/components/info-chip/info-chip.css.ts
var n = "bo4hpb0", r = {
	active: "bo4hpb1",
	default: "bo4hpb2",
	muted: "bo4hpb3"
};
//#endregion
//#region src/components/info-chip/info-chip.tsx
function i({ children: i, className: a, tone: o = "default", ...s }) {
	return /* @__PURE__ */ t("span", {
		...s,
		className: e(n, r[o], a),
		children: i
	});
}
//#endregion
export { i as InfoChip };

//# sourceMappingURL=info-chip.js.map